import { fetcher } from './../index';
import useSWR from 'swr';
import { useSelector } from 'react-redux';
import { selectCustomerId } from './../../modules/selectors';
import { OrderHistoryItem } from '../../types/orders/orderHistory';

const transformData = (data: Array<any>): Array<OrderHistoryItem> | undefined => {
	if (!data) return undefined;

	return data.map((item: any) => ({
		id: item.id,
		deliveryDate: item.deliveredOn ? new Date(item.deliveredOn) : undefined,
		submittedAt: item.submittedOn ? new Date(item.submittedOn) : undefined,
		customerRef: item.customerReference,
		reference: item.erpOrderNr,
		origin: item.origin,
		pdf: item.pdf,
		status: item.status,
		numberOfLines: item.numberOfLines
	}));
};

export default function useOrderHistory(customerIdProp?: string) {
	const customerId = useSelector(selectCustomerId);
	const customerIdToUse = customerIdProp || customerId;
	const { data, error } = useSWR(`/api/customer.order.history/${customerIdToUse}/orders`, fetcher);

	return {
		orderHistory: transformData(data),
		error
	};
}
